import Iconify from "src/components/Iconify";
import { Button } from "../ui/button";

const OptionsSelect = ({ title, options, value, changeValue }) => {
    return (
        <div className="space-y-4">
            {title && (
                <p className="text-sm text-gray-600">
                    {title}
                </p>
            )}

            <div className="flex space-x-4">
                {options.map((method) => (
                    <Button
                        key={method.value}
                        variant={value === method.value ? "default" : "outline"}
                        onClick={() => changeValue(method.value)}
                        className={`w-full h-8 text-[12px] flex items-center justify-center ${value === method.value
                                ? method.color || "bg-violet-500"
                                : ""
                            }`}
                    >
                        {method.icon && <Iconify icon={method.icon} />}
                        <span>{method.label}</span>
                    </Button>
                ))}
            </div>
        </div>
    )
}

export default OptionsSelect;